import React from "react";
import { TypeAnimation } from "react-type-animation";
import "../App.css";
import { useNavigate } from "react-router-dom";
import { Button, ButtonGroup } from "@aws-amplify/ui-react";
import { Routes, Route } from "react-router-dom";
import KanaSRS from "../projects/KanaSRS";
import TemplateProject from "../projects/TemplateProject";
import Kousokukaki from "../projects/Kousokukaki";
import Policy from "../pages/Policy";

function Projects() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "fit-content",
      }}
    >
      <TypeAnimation sequence={["projects"]} className="text-animation" />
      <ButtonGroup>
        <Button isFullWidth={true} onClick={() => navigate("kanasrs")}>
          KanaSRS
        </Button>
        <Button isFullWidth={true} onClick={() => navigate("kousokukaki")}>
          Kousokukaki
        </Button>
        <Button isFullWidth={true} onClick={() => navigate("project3")}>
          Project 3
        </Button>
      </ButtonGroup>

      <Routes>
        <Route path="kanasrs" element={<KanaSRS />} />
        <Route path="kousokukaki" element={<Kousokukaki />} />
        <Route path="project3" element={<TemplateProject />} />
      </Routes>
    </div>
  );
}

export default Projects;
